<template>
  <div class="browse">
    <!-- Modal popup for long descriptions -->
    <description-modal @close="closeDesc" :show="descModalActive" :name="clickedItem.name" :description="clickedItem.description">
    </description-modal>
  
    <div class="container"> 
      <browse-toolbar></browse-toolbar>
      <browse-table v-if="mode === 'table'" @descClicked="descClicked"></browse-table>
      <browse-tiles v-else></browse-tiles>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DescriptionModal from '@/components/DescriptionModal';
import BrowseToolbar from '@/components/browse/BrowseToolbar';
import BrowseTable from '@/components/browse/BrowseTable';
import BrowseTiles from '@/components/browse/BrowseTiles';
import notifyMixin from '@/mixins/notify';

export default {
  name: 'browse',
  mixins: [notifyMixin],
  data() {
    return {
      error: null,
      descModalActive: false,
      clickedItem: {
        name: '',
        description: '',
      },
    };
  },
  mounted() {
    this.fetchFoodItems().catch((error) => { this.error = error; });
  },
  methods: {
    descClicked(fi) {
      this.clickedItem = fi;
      this.descModalActive = true;
    },
    closeDesc() {
      this.descModalActive = false;
    },
    ...mapActions('browse', ['fetchFoodItems']),
  },
  computed: {
    ...mapGetters('browse', {
      sort: 'sort',
      selectedTypes: 'types',
      selectedCategories: 'categories',
      mode: 'mode',
    }),
    sortField() {
      return this.sort.field;
    },
    sortOrder() {
      return this.sort.order;
    },
  },
  watch: {
    sortField() {
      this.fetchFoodItems().catch((error) => { this.error = error; });
    },
    sortOrder() {
      this.fetchFoodItems().catch((error) => { this.error = error; });
    },
    selectedTypes() {
      this.fetchFoodItems().catch((error) => { this.error = error; });
    },
    selectedCategories() {
      this.fetchFoodItems().catch((error) => { this.error = error; });
    },
  },
  components: {
    DescriptionModal,
    BrowseToolbar,
    BrowseTable,
    BrowseTiles,
  },
};
</script>

<style lang="sass" scoped>
</style>




// WEBPACK FOOTER //
// src/components/browse/Browse.vue